import Vue from 'vue'

class CertificatesofCompletionService {
  /**
   * Return the resource url.
   *
   * @returns {String|Error} The resource url
   */
  static get resource() {
    throw new Error('resource getter not defined.')
  }

  static createCertificateOfCompletion(payload) {
    const url = `${this.resource}/certificate-of-completion`
    return Vue.axios
      .post(url, payload)
      .then((res) => res.data)
      .catch((err) => {
        throw err // re-throw so the component catch block receives it
      })
  }
  static search(params = {}) {
    const url = `${this.resource}/certificate-of-completion`
    return Vue.axios.get(url, { params }).then((res) => res.data)
  }

  static getCertificateContractDetails(contractId, transactionDate) {
    const url = `${this.resource}/certificate-of-completion/contract-details/${contractId}`
    return Vue.axios
      .get(url, {
        params: { transactionDate },
      })
      .then((res) => res.data)
  }

  // CertficateService.js
  static getCertificatesOfCompletion(contractId, transactionDate) {
    const url = `${this.resource}/certificate-of-completion`
    return Vue.axios
      .get(url, {
        params: {
          contract: contractId,
          date: transactionDate, // Use the correct key expected by your backend
          limit: 1000000, // Force limit as a number
          skip: 0,
        },
      })
      .then((res) => res.data)
  }
  static getCertificateOfCompletionById(id) {
    const url = `${this.resource}/certificate-of-completion/${id}`
    return Vue.axios.get(url, {}).then((res) => res.data)
  }

  static getCertificateLogs(page = 1, limit = 10) {
    const url = `${this.resource}/history`

    return Vue.axios
      .get(url, {
        params: {
          page,
          limit,
          sort: '-updatedAt',
          modelName: 'in:[CertificateOfCompletion]',
        },
      })
      .then((res) => res.data)
  }
}

export default CertificatesofCompletionService
